import axios from 'axios';
import type {
  IGetDocumentListParams,
  IGetDocumentListRequest,
  IGetDocumentListResponse,
} from '@/app-package';

export const getDocumentList = async (params: IGetDocumentListParams) => {
  const config: IGetDocumentListRequest = {
    url: `/billing/document_list/${params.billingCustomerNumber}`,
    method: 'get',
  };
  try {
    const { data } = await axios.request<IGetDocumentListResponse>(config);
    return data;
  } catch (error) {
    // Check for 404 error and return an empty array
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw error;
  }
};

export default getDocumentList;
